import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

const careplanCartLineItemVariants = tv({
  base: "flex items-start justify-between gap-3",
});

export const CareplanCartLineItem = ({ children, className, ...props }: ComponentProps<"div">) => {
  return (
    <div className={careplanCartLineItemVariants({ className })} {...props}>
      {children}
    </div>
  );
};
